// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"2e6944523b237e3b","6831":"9108db6784c6767b","8503":"519c9eeeb9357e37","9683":"3a17706ccd372c08"}[chunkId] + ".js";
};